import { DialogTitle } from '@aibees/shared/components';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { CreditEffect } from '@aibees/shared/features/subscription-manager/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames, fDate } from '@aibees/shared/utils';
import {
  Card,
  CardContent,
  DialogContent,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { memo, useEffect } from 'react';
import { DialogFooter } from './components/dialog-footer';
import { StatusCard } from './components/status-card';
import * as Styled from './styles';
import * as SX from './sx';
import type { PaymentSuccessDialogProps as Props } from './types';

export const PaymentSuccessDowngradeDialog = memo(({ className }: Props) => {
  const state = useBoolean();
  const { data } = useCurrentSubscriptionApi();

  useEffect(() => {
    if (window.location.hash.includes('#successDowngrade')) {
      state.setValue(true);
    }
  }, [window.location.hash]);

  const closeModal = () => {
    window.location.hash = '';
    state.onFalse();
  };

  return (
    <Styled.Wrapper
      open={state.value}
      className={classnames('PaymentSuccessDialog', className)}
      sx={SX.root}
    >
      <DialogTitle title="Downgrade Successful!" onClose={closeModal} />
      <DialogContent>
        <Stack gap={1}>
          <StatusCard />
          <Stack sx={SX.content} gap={1}>
            <CreditEffect
              creditAmount={Number(data?.current?.plan?.metadata.request)}
              label="Current Credit Plan"
              sx={SX.creditEffect}
            />
            <Card variant="outlined">
              <CardContent>
                <Typography variant="body3" fontWeight={500} color="grey.700">
                  Important Note
                </Typography>
                <Divider sx={SX.divider} />
                <Typography
                  variant="body4"
                  fontWeight={400}
                  color="common.black"
                >
                  Your are on {data?.current?.plan?.metadata.request} Credit
                  Plan and your next Charge will be on{' '}
                  <Typography
                    variant="body4"
                    fontWeight={600}
                    color="common.black"
                    component="span"
                  >
                    {fDate(data?.current?.currentPeriodEnd)}
                  </Typography>
                </Typography>
              </CardContent>
            </Card>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogFooter
        closeModal={closeModal}
        onCancel={closeModal}
        onConfirm={closeModal}
      />
    </Styled.Wrapper>
  );
});

PaymentSuccessDowngradeDialog.displayName = 'PaymentSuccessDowngradeDialog';
